module.exports = __webpack_public_path__ + "img/what6.5e61e6af.png";